import {
  hasConventionalUnits,
  getWaitlistProgramNames,
} from '../../../containers/ConvertToApplicantModal/utils/programs';
import { CONVENTIONAL_PROGRAM_NAME } from '../../../containers/ConvertToApplicantModal/constants';

// Mirrors the backend's eligibility rule for the "keep application
// In-Process" cancel option (ENG-29636): eligible when the property mixes
// in conventional units, or when at least one of its affordable programs
// isn't enabled on the waitlist.
export const getShowContinueOption = ({
  propertyClassName,
  propertyAffordablePrograms,
  waitlistConfiguration,
}) => {
  const waitlistPrograms = getWaitlistProgramNames(waitlistConfiguration);
  return (
    hasConventionalUnits(propertyClassName) ||
    (propertyAffordablePrograms ?? []).some(
      (name) => !waitlistPrograms.includes(name),
    )
  );
};

// Get programs available for the applicant to continue with
// (programs not enabled in the waitlist, plus Conventional if property supports it)
export const getAvailablePrograms = ({
  propertyClassName,
  propertyAffordablePrograms,
  waitlistConfiguration,
}) => {
  const waitlistPrograms = new Set(
    getWaitlistProgramNames(waitlistConfiguration),
  );
  const availableAffordablePrograms = (propertyAffordablePrograms ?? []).filter(
    (name) => name && !waitlistPrograms.has(name),
  );

  const programs = [...availableAffordablePrograms];
  if (hasConventionalUnits(propertyClassName)) {
    programs.push(CONVENTIONAL_PROGRAM_NAME);
  }

  return programs.sort();
};

export const resolveCancelMutate = (
  continueApplication,
  { cancelMutate, cancelKeepInProcessMutate },
) => (continueApplication === true ? cancelKeepInProcessMutate : cancelMutate);
